// src/pages/Projects/index.js
// 第1-5行（修改导入语句）
import React, { useState, useEffect } from "react";
import { Card, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

// 天赋树项目数据 - 添加跳转链接
// 天赋树项目数据 - 重新设计的布局（优化版）
const talentTreeData = [
// 【中心原点】根节点 - 中心点
{ id: 1, name: "他心游", level: 0, x: 50, y: 50, connections: [2, 3, 4, 9, 13, 16, 19], unlocked: true, link: "#" },
// 【第一圈】主分支 - 均匀分布
{ id: 2, name: "文本生成", level: 1, x: 50, y: 25, connections: [5], unlocked: false, link: "#", description: "文本生成模块，支持多种文本生成功能，包括剑来文本生成等子项目。" }, // 顶部
{ id: 3, name: "图像识别", level: 1, x: 65, y: 35, connections: [12], unlocked: false, link: "#", description: "图像识别模块，支持多种图像识别功能，包括狗类识别等子项目。" }, // 右上
{ id: 4, name: "网页", level: 1, x: 65, y: 65, connections: [8], unlocked: false, link: "#", description: "网页项目模块，展示做的常规各个网页项目。" }, // 右下
{ id: 9, name: "爬虫", level: 1, x: 50, y: 75, connections: [10, 11], unlocked: false, link: "#", description: "爬虫模块，支持多种爬虫功能，包括JS逆向和常规爬虫等子项目。" }, // 底部
{ id: 13, name: "图像生成", level: 1, x: 35, y: 65, connections: [14], unlocked: false, link: "#", description: "图像生成模块，支持多种图像生成功能，包括基于Diffusion模型的图像生成等子项目。" }, // 左下
{ id: 16, name: "智能体", level: 1, x: 35, y: 35, connections: [17], unlocked: false, link: "#", description: "各个智能体项目模块，展示做的常规各个智能体项目。" }, // 左上
{ id: 19, name: "目标检测", level: 1, x: 70, y: 50, connections: [20], unlocked: false, link: "#", description: "目标检测模块，基于YOLO技术实现物体识别与跟踪。" }, // 右侧新分支

// 【第二圈】细分分支
{ id: 5, name: "Transformer", level: 2, x: 50, y: 12, connections: [6], unlocked: false, link: "#", description: "基于Transformer模型的文本生成项目，支持多种文本生成功能。" }, // 顶部延伸
{ id: 12, name: "CNN", level: 2, x: 78, y: 28, connections: [7], unlocked: false, link: "#", description: "基于CNN卷积神经网络的图像识别项目，支持多种图像识别功能。" }, // 右上延伸
{ id: 8, name: "搭把手", level: 2, x: 78, y: 72, connections: [], unlocked: false, link: "https://my-friends-5.pages.dev" }, // 右下延伸
{ id: 10, name: "JS逆向", level: 2, x: 65, y: 90, connections: [], unlocked: false, link: "/post/1766119074019"}, // 底部延伸右 - 指向爬虫进阶 JS逆向文章
{ id: 11, name: "常规", level: 2, x: 35, y: 90, connections: [], unlocked: false, link: "/post/1770481247493"}, // 底部延伸左 - 指向爬虫基础文章
{ id: 14, name: "Diffusion", level: 2, x: 22, y: 72, connections: [15], unlocked: false, link: "#", description: "基于Diffusion扩散模型的图像生成项目，支持多种图像生成功能。" }, // 左下延伸
{ id: 17, name: "Coze", level: 2, x: 22, y: 28, connections: [18], unlocked: false, link: "#", description: "基于Coze平台的视频生成项目，各种智能体。" }, // 左上延伸
{ id: 20, name: "YOLO", level: 2, x: 85, y: 50, connections: [21], unlocked: false, link: "#", description: "基于YOLO算法的目标检测模型实现。" }, // 右侧延伸

// 【第三圈】具体项目
{ id: 6, name: "剑来", level: 3, x: 50, y: 0, connections: [], unlocked: false, link: "/sword-text-gen" }, // 顶部尖端
{ id: 7, name: "狗类", level: 3, x: 90, y: 20, connections: [], unlocked: false, link: "/dog-recognition" }, // 右上尖端
{ id: 15, name: "SD", level: 3, x: 10, y: 80, connections: [], unlocked: false, link: "/lora-finetuning" }, // 左下尖端
{ id: 18, name: "门之钥", level: 3, x: 10, y: 20, connections: [], unlocked: false, link: "/door-key" }, // 左上尖端
{ id: 21, name: "跟踪哈士奇", level: 3, x: 100, y: 50, connections: [], unlocked: false, link: "/husky-tracking"}, // 右侧尖端
];

export default function Projects() {
  const findNode = (id) => talentTreeData.find(node => node.id === id);
  const navigate = useNavigate();
  
  // 激活状态：所有节点默认开启
  const [activeNodes, setActiveNodes] = useState(() => {
    const initialActive = {};
    talentTreeData.forEach(node => initialActive[node.id] = true);
    return initialActive;
  });
  
  const [activeLines, setActiveLines] = useState({});
  // 节点解锁状态
  const [unlockedNodes, setUnlockedNodes] = useState({
    1: true // 根节点默认解锁
  });

  // 添加浮动对话框状态
  const [floatDialog, setFloatDialog] = useState({
    visible: false,
    nodeId: null,
    position: { x: 0, y: 0 }
  });

  // 添加能量传递动画状态
  const [energyTransfer, setEnergyTransfer] = useState(false);
  // 存储能量传递的线状态
  const [energyLines, setEnergyLines] = useState({});

  // 添加抖动动画状态
  const [shakingNodes, setShakingNodes] = useState({});
  // 添加警告文字显示状态
  const [warningText, setWarningText] = useState({
    visible: false,
    position: { x: 0, y: 0 }
  });

  // 核心动画：按层级分组执行充能和解锁
  useEffect(() => {
    // 按层级分组节点
    const nodesByLevel = {
      0: talentTreeData.filter(node => node.level === 0),
      1: talentTreeData.filter(node => node.level === 1),
      2: talentTreeData.filter(node => node.level === 2),
      3: talentTreeData.filter(node => node.level === 3) // 添加第三级节点
    };

    const allLines = [];
    talentTreeData.forEach(node => {
      node.connections.forEach(targetId => {
        const lineId = `${node.id}-${targetId}`;
        const sourceNode = findNode(node.id);
        const targetNode = findNode(targetId);
        allLines.push({ lineId, sourceNode, targetNode, level: sourceNode.level });
      });
    });
    
    // 按层级顺序执行动画
    let delay = 300; // 初始延迟
    const maxLevel = 3; // 最大层级改为3，包含第三级节点
    
    // 定义层级动画函数
    const animateLevel = (level) => {
      if (level > maxLevel) return;
      
      // 获取当前层级的所有节点和连接线
      const currentLevelNodes = nodesByLevel[level];
      const linesToCurrentLevel = allLines.filter(line => line.targetNode.level === level);
      
      // 为当前层级的所有连接线同时开始充能动画
      setTimeout(() => {
        linesToCurrentLevel.forEach(({ lineId }) => {
          setActiveLines(prev => ({ ...prev, [lineId]: "charging" }));
          
          // 充能完成后标记为已充电
          setTimeout(() => {
            setActiveLines(prev => ({ ...prev, [lineId]: "charged" }));
            // 充能完成后立即启动该线路的能量传递动画
            setEnergyTransfer(true);
            setEnergyLines(prev => ({ ...prev, [lineId]: true }));
          }, 2000); // 充能动画时长2秒
        });
        
        // 在充能动画开始后延迟一段时间，为当前层级的所有节点同时开始解锁动画
        setTimeout(() => {
          currentLevelNodes.forEach(node => {
            if (!node.alwaysLocked) {
              setUnlockedNodes(prev => ({ ...prev, [node.id]: true }));
            }
          });
        }, 800);
        
        // 进入下一层级的动画
        animateLevel(level + 1);
      }, delay);
      
      // 层级之间的间隔时间
      delay += 1000; // 1秒间隔，确保充能(2秒)和解锁(1.5秒)动画都完成
    };
    
    // 从第1层开始动画（根节点已经解锁）
    animateLevel(1);
    
    // 计算所有动画完成后的总时间
    // 初始延迟 + (层级数 * (层级间隔 + 充能动画 + 解锁动画))
    const totalAnimationTime = 300 + (maxLevel * (1000 + 2000 + 800));
    
    // 在所有动画完成后启动能量传递动画
    setTimeout(() => {
      setEnergyTransfer(true);
      // 启动连接线能量传递动画
      const transferDelay = 300;
      allLines.forEach((line, index) => {
        setTimeout(() => {
          setEnergyLines(prev => ({ ...prev, [line.lineId]: true }));
        }, index * transferDelay);
      });
    }, totalAnimationTime);
  }, []);

  // 计算两点之间的距离（用于设置合适的stroke-dasharray）
  const calculateDistance = (x1, y1, x2, y2) => {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
  };

  // 连线样式
  const getLineStyle = (lineId) => {
    if (activeLines[lineId] === "charging") {
      return { 
        stroke: "var(--theme-primary)", 
        strokeWidth: 3, 
        strokeDasharray: "800", 
        strokeDashoffset: "800", 
        animation: "charge 2s linear forwards", 
        filter: "drop-shadow(0 0 6px var(--theme-primary))" 
      };
    }
    if (activeLines[lineId] === "charged") {
      return { 
        stroke: "var(--theme-accent)", 
        strokeWidth: 3, 
        filter: "drop-shadow(0 0 10px var(--theme-accent))" 
      };
    }
    return { stroke: "transparent" };
  };

  // 能量传递线样式
  const getEnergyLineStyle = (sourceNode, targetNode) => {
    // 计算线段长度（使用百分比计算实际像素长度）
    const svgWidth = window.innerWidth * 0.8;
    const svgHeight = window.innerHeight * 0.8;
    const x1 = sourceNode.x / 100 * svgWidth;
    const y1 = sourceNode.y / 100 * svgHeight;
    const x2 = targetNode.x / 100 * svgWidth;
    const y2 = targetNode.y / 100 * svgHeight;
    const distance = calculateDistance(x1, y1, x2, y2);
    
    // 能量团的长度
    const energyBallLength = 6;
    
    return {
      stroke: "var(--theme-accent)",
      strokeWidth: 6,
      strokeDasharray: `${energyBallLength}, ${distance}`,
      strokeDashoffset: "0",
      filter: "drop-shadow(0 0 15px var(--theme-accent))",
      animation: "energyFlow 4s linear infinite" // 调整速度以适应不同长度
    };
  };

  // 节点样式 - 移除闪烁效果
  const getNodeStyle = (node) => {
    // 根节点始终解锁
    if (node.level === 0) {
      return {
        width: 180,
        background: "var(--theme-card-bg)", 
        border: `2px solid var(--theme-primary)`,
        borderRadius: "50%", 
        minHeight: 180,
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        textAlign: "center", 
        boxShadow: `0 0 15px var(--theme-primary)`,
        backdropFilter: "blur(8px)"
      };
    }
    
    // 非根节点根据解锁状态显示不同样式，并添加缩短的过渡动画
    return {
      width: 180,
      background: unlockedNodes[node.id] ? "var(--theme-card-bg)" : "rgba(40, 40, 40, 0.8)", 
      border: unlockedNodes[node.id] ? `2px solid var(--theme-primary)` : `2px solid #666666`,
      borderRadius: 10, 
      minHeight: "auto",
      display: "flex", 
      flexDirection: "column",
      alignItems: "center", 
      justifyContent: "center",
      textAlign: "center", 
      boxShadow: unlockedNodes[node.id] ? `0 0 15px var(--theme-primary)` : "none",
      backdropFilter: "blur(8px)",
      opacity: unlockedNodes[node.id] ? 1 : 0.6,
      transition: "all 1s ease-out", // 解锁动画缩短为1.5秒
      animation: shakingNodes[node.id] ? "shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both" : "none"
    };
  };

  // 节点文本样式 - 添加缩短的过渡动画
  const getNodeTextStyle = (node) => {
    return { 
      fontSize: 13, 
      fontWeight: "600", 
      color: node.level === 0 || unlockedNodes[node.id] ? "var(--theme-primary)" : "#999999", 
      marginBottom: 8,
      transition: "color 1.2s ease-out" // 缩短的颜色过渡
    };
  };

  // 处理锁住节点的点击事件
  const handleLockedNodeClick = (node) => {
    // 触发抖动动画
    setShakingNodes(prev => ({ ...prev, [node.id]: true }));
    
    // 显示警告文字 - 修改：将文字位置设置为节点中心
    setWarningText({
      visible: true,
      position: { x: node.x, y: node.y } // 显示在节点中心
    });
    
    // 2秒后停止抖动
    setTimeout(() => {
      setShakingNodes(prev => ({ ...prev, [node.id]: false }));
    }, 2000);
    
    // 3秒后隐藏警告文字
    setTimeout(() => {
      setWarningText(prev => ({ ...prev, visible: false }));
    }, 3000);
  };

  // 打开项目链接
  const openProjectLink = (node, event) => {
    event.stopPropagation();
    
    if (node.description) {
      // 有description属性的节点显示浮动对话框
      setFloatDialog({ 
        visible: true,
        nodeId: node.id,
        position: { 
          x: node.x, // 使用节点的百分比位置
          y: node.y 
        }
      });
    } else if (node.link.startsWith('/')) {
      navigate(node.link); // 在当前应用内跳转
    } else {
      window.open(node.link, "_blank"); // 外部链接新窗口打开
    }
  };

  // 关闭浮动对话框
  const closeFloatDialog = (event) => {
    event.stopPropagation();
    setFloatDialog(prev => ({ ...prev, visible: false }));
  };

  // 点击画布其他区域关闭对话框
  const handleCanvasClick = () => {
    setFloatDialog(prev => ({ ...prev, visible: false }));
  };

  return (
    // 透明背景
    <div style={{ 
      width: "100%", 
      minHeight: "90vh", 
      margin: 0, 
      padding: 0,
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center",
      background: "transparent"
    }}>
      <style>
        {
          `
          /* 连线充能动画 */
          @keyframes charge { from { stroke-dashoffset: 800; } to { stroke-dashoffset: 0; } }
          /* 节点展开动画 */
          @keyframes nodeBlast { from { opacity:0; transform: translate(-50%,-50%) scale(0); } to { opacity:1; transform: translate(-50%,-50%) scale(1); } }
          /* 对话框淡入动画 */
          @keyframes dialogFadeIn { from { opacity:0; transform: translate(-50%,-50%) translateY(10px); } to { opacity:1; transform: translate(-50%,-50%) translateY(0); } }
          /* 能量流动动画 */
          @keyframes energyFlow {
            from { stroke-dashoffset: 0; }
            to { stroke-dashoffset: -100%; } /* 移动与stroke-dasharray总长度相等的距离 */
          }
          /* 抖动动画 - 修复版：仅在原地抖动 */
          @keyframes shake {
            10%, 90% { transform: translate(-2px, -2px); }
            20%, 80% { transform: translate(2px, 2px); }
            30%, 50%, 70% { transform: translate(-4px, -4px); }
            40%, 60% { transform: translate(4px, 4px); }
          }
          /* 警告文字淡入淡出 */
          @keyframes warningFade {
            0% { opacity: 0; transform: translate(-50%, 10px); }
            20%, 80% { opacity: 1; transform: translate(-50%, 0); }
            100% { opacity: 0; transform: translate(-50%, -10px); }
          }
          /* 脉冲动画 */
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `
        }
      </style>

      {/* 天赋树主画布 */}
      <div 
        className="talent-tree-canvas"
        style={{ 
          width: "100%", 
          height: "90vh", 
          position: "relative", 
          overflow: "visible",  // 从 hidden 改为 visible，允许节点内容溢出显示
          borderRadius: 12,
          background: "transparent"
        }}
        onClick={handleCanvasClick}
      >
        {/* 1. 连线层（底层） */}
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none" }}>
          {talentTreeData.map(node => 
            node.connections.map(targetId => {
              const targetNode = findNode(targetId);
              const lineId = `${node.id}-${targetId}`;
              return targetNode && (
                <svg key={lineId} style={{ position: "absolute", top:0, left:0, width:"100%", height:"100%" }}>
                  <line x1={`${node.x}%`} y1={`${node.y}%`} x2={`${targetNode.x}%`} y2={`${targetNode.y}%`} strokeLinecap="round" style={getLineStyle(lineId)} />
                </svg>
              );
            })
          )}
        </div>

        {/* 2. 能量传递层（中间层） */}
        {energyTransfer && (
          <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 5 }}>
            {talentTreeData.map(node => 
              node.connections.map(targetId => {
                const targetNode = findNode(targetId);
                const lineId = `${node.id}-${targetId}`;
                return targetNode && energyLines[lineId] && (
                  <svg key={`energy-${lineId}`} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                    <line
                      x1={`${node.x}%`}
                      y1={`${node.y}%`}
                      x2={`${targetNode.x}%`}
                      y2={`${targetNode.y}%`}
                      strokeLinecap="round"
                      style={getEnergyLineStyle(node, targetNode)}
                    />
                  </svg>
                );
              })
            )}
          </div>
        )}

        {/* 3. 警告文字层 */}
        {warningText.visible && (
          <div
            style={{
              position: "absolute",
              left: `${warningText.position.x}%`,
              top: `${warningText.position.y}%`,
              transform: "translate(-50%, -50%)", // 修改：改为双向居中
              zIndex: 20,
              color: "#ff0000",
              fontSize: "14px",
              fontWeight: "bold",
              textShadow: "0 0 10px rgba(255, 0, 0, 0.8)",
              animation: "warningFade 3s ease-out forwards"
            }}
          >
            你知道的太多了，呵呵...
          </div>
        )}

        {/* 4. 节点层（上层） */}
        <div style={{ position: "absolute", top:0, left:0, right:0, bottom:0, zIndex: 10 }}>
          {talentTreeData.map(node => (
            <div 
              key={node.id}
              className="node-container"
              style={{
                position: "absolute", left: `${node.x}%`, top: `${node.y}%`,
                transform: "translate(-50%, -50%)", zIndex: 10, cursor: "pointer",
                opacity: activeNodes[node.id] ? 1 : 0,
                animation: activeNodes[node.id] ? "nodeBlast 0.8s cubic-bezier(0.25, 1, 0.5, 1) forwards" : "none",
                animationDelay: node.level * 500 + "ms" // 根据节点层级延迟显示
              }}
              onClick={() => !unlockedNodes[node.id] && handleLockedNodeClick(node)}
            >
              <Card 
                style={getNodeStyle(node)}
                bodyStyle={{ padding: "10px", color: "var(--theme-text)" }}
              >
                                {/* 所有节点统一只显示标题 */}
                                {node.level === 0 ? (
                                  <div>
                                    <img 
                                      src="/favicon.ico" 
                                      alt="Website Icon" 
                                      style={{ 
                                        width: 24, 
                                        height: 24, 
                                        marginBottom: 4,
                                        transition: "all 1.2s ease-out"
                                      }} 
                                    />
                                    <div style={getNodeTextStyle(node)}>{node.name}</div>
                                  </div>
                                ) : (
                  <div>
                    {/* 锁住的节点显示锁图标 */}
                    {!unlockedNodes[node.id] && (
                      <LockOutlined style={{ 
                        color: "#ff0000", 
                        fontSize: 20, 
                        marginBottom: 4,
                        animation: "pulse 1.5s infinite"
                      }} />
                    )}
                    <div style={getNodeTextStyle(node)}>{node.name}</div>
                    {/* 只有解锁的节点才显示详情按钮 */}
                    {unlockedNodes[node.id] && (
                      <Button
                        type="primary"
                        size="small"
                        onClick={(e) => openProjectLink(node, e)}
                        style={{
                          background: "var(--theme-primary)",
                          borderColor: "var(--theme-primary)",
                          color: "white",
                          fontSize: "10px"
                        }}
                      >
                        详情
                      </Button>
                    )}
                  </div>
                )}
              </Card>
            </div>
          ))}
        </div>

        {/* 5. 浮动对话框层（最上层） */}
        {floatDialog.visible && (
          <div
            style={{
              position: "absolute",
              left: `${floatDialog.position.x}%`,
              top: `${floatDialog.position.y}%`,
              transform: "translate(-50%, calc(-100% - 10px))", // 显示在节点上方
              zIndex: 100,
              width: "250px",
              background: "var(--theme-card-bg)",
              border: "2px solid var(--theme-card-border)",
              borderRadius: "8px",
              padding: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3), 0 0 10px var(--theme-primary)",
              backdropFilter: "blur(10px)",
              animation: "dialogFadeIn 0.3s ease-out forwards",
              pointerEvents: "auto" // 允许对话框接收事件
            }}
          >
            {/* 对话框标题 */}
            <div style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "var(--theme-primary)",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              {talentTreeData.find(n => n.id === floatDialog.nodeId)?.name}
              <Button
                type="text"
                size="small"
                onClick={closeFloatDialog}
                style={{ color: "var(--theme-text)", padding: "0", lineHeight: "1" }}
              >
                ×
              </Button>
            </div>
            
            {/* 对话框内容 */}
            <div style={{
              fontSize: "12px",
              color: "var(--theme-text)",
              lineHeight: "1.5"
            }}>
              {talentTreeData.find(n => n.id === floatDialog.nodeId)?.description || "暂无详细信息"}
            </div>
            
            {/* 对话框小三角 */}
            <div style={{
              position: "absolute",
              bottom: "-8px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "0",
              height: "0",
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderTop: "8px solid var(--theme-card-bg)"
            }}></div>
            <div style={{
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "0",
              height: "0",
              borderLeft: "9px solid transparent",
              borderRight: "9px solid transparent",
              borderTop: "9px solid var(--theme-card-border)"
            }}></div>
          </div>
        )}
      </div>
    </div>
  );
}